const storage = {
    not_configured: 'ストレージプロバイダが設定されていません。',
    missing_parameter: 'ストレージプロバイダの{{parameter}}が欠落しています。',
    upload_error: 'ファイルのアップロードに失敗しました。',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
